module.exports = __webpack_public_path__ + "static/media/king.b3521162.svg";